import { Injectable } from '@angular/core';
import { HttpDataService } from '../../shared/http/http-data.service';

import { ICodeValue, IValueObject } from '../../../type_definitions/datatypes';

export interface IUploadContext {
  importId?:number;
  columns?:IFileColumn[];
  headers?:IFileHeader[];
  data?:IFileData;
  sheets?:string[];
}

export interface IUploadResponse {
  success:number;
  columns?:IFileColumn[];
  warnings:IUploadMessage[];
  errors:IUploadMessage[];
  status:boolean;
}

export interface IFileColumn {
  colId:number;
  sheetColumnName:string;
  sequence:number;
  required?:boolean;
  code?:string;
  name?:string;
  possibleValues?:IValueObject[];
  valueMappings?:ICodeValue[];
}

export interface IFileHeader {
  code:string;
  name:string;
}

export interface IFileData {
  sheetName:string;
  data:Array<any[]>;
}

export interface IUploadMessage {
  rowId:number;
  uploaded:boolean;
  error:string;
  errorCode:string;
}

@Injectable()
export class UploadDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public getUploadContext(uploadId:number, sheetName:string):Promise<IUploadContext> {
    return this.httpDataService.doPOST(
      `rest/uploads/context`,
      { uploadId },
      { sheetName },
      undefined,
      'Error loading upload context'
    );
  }

  public submitColumns(test:boolean, sheetName:string, columns:IFileColumn[], importId:number, context:any):Promise<IUploadResponse> {
    return this.httpDataService.doPOST(
      `rest/uploads`,
      { test },
      {
        columns,
        importId,
        context,
        sheetName
      },
      undefined,
      'Error submitting columns'
    );
  }

  public getUploadResults(uploadId:number):Promise<IUploadResponse> {
    return this.httpDataService.doGET(
      `rest/uploads/results`,
      { uploadId },
      undefined,
      'Error getting upload results'
    );
  }
}